<template>
  <div class="container-fluid">
    <PainelAcesso :exibirFormulario="flags.exibirSignupRegistro" :exibirImagem="!flags.exibirSignupRegistroSucesso">
      <template #cabecalho >
        <div class="modal-title ">
          <div class="d-flex justify-content-center ">
            <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 form-group">
              <h5 class="textos text-secondary">
                <div>Cadastro de conta</div>
                <span>Preencha os dados abaixo.</span>
              </h5>
              <spinnerProcessando cssClass="ml-2 mb-2" :status="desabilitarCampos" :mensagem="flagsDeControle.manipulandoDados.mensagem || flagsDeControle.carregandoDados.mensagem" />
            </div>
          </div>
        </div>
      </template>
      <template #corpo>
        <form>
          <div v-show="flags.escritorioNaoLogado" class="avisoDanger text-left mb-2">{{erroValidacaoCampos.escritorio}}</div>
          <div class="form-row justify-content-center">
            <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 form-group">
              <select class="form-control form-control-md" id="tipo" name="tipo" v-model="dadosFormulario.tipo" @change="eventoAlterarTipoPessoa()" :disabled="desabilitarCampos">
                <option selected disabled :value="0">- - - - - - -</option>
                <option
                  v-for="tipoPessoa in dataSelect.tipo"
                  :key="tipoPessoa.tipo"
                  :value="tipoPessoa.tipo"
                >
                  {{ tipoPessoa.label }}
                </option>
              </select>
            </div>
          </div>
          <div v-if="ehPessoaFisica">

            <div class="form-row justify-content-center">
              <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 form-group">
                <label class="small text-secondary" for="nome">Nome</label>
                <input
                  id="nome"
                  type="text"
                  class="form-control form-control-md corBordaCampo placeholder"
                  name="nome"
                  v-model="dadosFormulario.nome"
                  maxlength="50"
                  :disabled="desabilitarCampos"
                />
                <div class="avisoDanger text-left" role="alert">
                  {{ erroValidacaoCampos.nome }}
                </div>
              </div>
            </div>

            <div class="form-row justify-content-center">
            <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 form-group">
              <label class="small text-secondary" for="cpf">CPF</label>
              <input
                id="cpf"
                type="text"
                class="form-control form-control-md corBordaCampo placeholder campo-DocumentoCpfCnpjAlfanumericoUppercase"
                v-model="dadosFormulario.cpf_cnpj"
                name="cpf_cnpj"
                v-mask="mascaraDocumento"
                maxlength="50"
                :disabled="desabilitarCampos"
              />
              <div class="avisoDanger text-left" role="alert">
                {{ erroValidacaoCampos.cpf_cnpj }}
              </div>
            </div>
            </div>

            <div class="form-row justify-content-center">
              <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 form-group">
                <label class="small text-secondary" for="email">Email</label>
                <input
                  id="email"
                  type="text"
                  class="form-control form-control-md corBordaCampo placeholder"
                  v-model="dadosFormulario.email"
                  name="email"
                  maxlength="50"
                  :disabled="desabilitarCampos"
                />

                <div class="avisoDanger text-left" role="alert">
                  {{ erroValidacaoCampos.email }}
                </div>
              </div>
            </div>

            <div class="form-row justify-content-center">
              <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 form-group">
                <label class="small text-secondary" for="numero_telefone">Telefone</label>
                <TelefoneInput
                  id="numero_telefone"
                  v-model="dadosFormulario.numero_telefone"
                  name="numero_telefone"
                  class="form-control form-control-md corBordaCampo placeholder"
                  :disabled="desabilitarCampos"
                  :mask="mascaraFone(dadosFormulario.numero_telefone)"
                />
                <div class="avisoDanger text-left" role="alert">
                  {{ erroValidacaoCampos.numero_telefone }}
                </div>
              </div>
            </div>
          </div>

          <div v-else>
            <div class="form-row justify-content-center">
            <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 form-group">
              <label class="small text-secondary" for="cnpj">CNPJ</label>
              <input
                id="cnpj"
                type="text"
                class="form-control form-control-md corBordaCampo placeholder campo-DocumentoCpfCnpjAlfanumericoUppercase"
                v-model="dadosFormulario.cpf_cnpj"
                name="cpf_cnpj"
                @change="buscarInformacoesDoCnpj"
                v-mask="mascaraDocumento"
                maxlength="50"
                :disabled="desabilitarCampos"
              />
              <div class="avisoDanger text-left" role="alert">
                {{ erroValidacaoCampos.cpf_cnpj }}
              </div>
            </div>
            </div>

            <div class="form-row justify-content-center">
              <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 form-group">
                <label class="small text-secondary" for="nome">Nome</label>
                <input
                  id="nome"
                  type="text"
                  class="form-control form-control-md corBordaCampo placeholder"
                  v-model="dadosFormulario.nome"
                  name="nome"
                  maxlength="50"
                  :disabled="desabilitarCampos"
                />
                <div class="avisoDanger text-left" role="alert">
                  {{ erroValidacaoCampos.nome }}
                </div>
              </div>
            </div>

            <div class="form-row justify-content-center" v-if="ehPessoaJuridica">
              <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 form-group">
                <label class="small text-secondary" for="razao_social">Razão Social</label>
                <input
                  id="razao_social"
                  type="text"
                  class="form-control form-control-md corBordaCampo placeholder"
                  v-model="dadosFormulario.razao_social"
                  name="razao_social"
                  maxlength="50"
                  :disabled="desabilitarCampos"
                />
                <div class="avisoDanger text-left" role="alert">
                  {{ erroValidacaoCampos.razao_social }}
                </div>
              </div>
            </div>

            <div class="form-row justify-content-center">
              <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 form-group">
                <label class="small text-secondary" for="email">Email</label>
                <input
                  id="email"
                  type="text"
                  class="form-control form-control-md corBordaCampo placeholder"
                  v-model="dadosFormulario.email"
                  name="email"
                  maxlength="50"
                  :disabled="desabilitarCampos"
                />

                <div class="avisoDanger text-left" role="alert">
                  {{ erroValidacaoCampos.email }}
                </div>
              </div>
            </div>

            <div class="form-row justify-content-center">
              <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 form-group">
                <label class="small text-secondary" for="numero_telefone">Telefone</label>
                <TelefoneInput
                  id="numero_telefone"
                  v-model="dadosFormulario.numero_telefone"
                  name="numero_telefone"
                  class="form-control form-control-md corBordaCampo placeholder"
                  :mask="mascaraFone(dadosFormulario.numero_telefone)"
                  :disabled="desabilitarCampos"
                />
                <div class="avisoDanger text-left" role="alert">
                  {{ erroValidacaoCampos.numero_telefone }}
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-center">
            <b-button
              @click="registrar"
              :disabled="desabilitarCampos"
              variant="btn btn-verde btn-block col-xl-8 col-lg-8 col-md-12 col-sm-12"
              >Cadastrar</b-button
            >
          </div>

          <div class="mt-2 form-row justify-content-center">
            <router-link class="linkOutroEscritorio textos" :to="{name: 'loginLite'}" :disabled="flags.efetuandoLogin">Acessar Sistema</router-link>
          </div>
        </form>
      </template>
    </PainelAcesso>
    <PainelAcesso :exibirFormulario="!flags.exibirSignupRegistro" :exibirImagem="flags.exibirSignupRegistroSucesso">
      <template #cabecalho>
        <div class="modal-title">
          <div class="d-flex justify-content-center mb-1">
            <h4 class="text-bold">
              <div>Bem vindo a <span class="text-success text-bold">MIRT &#x263A;</span></div>
            </h4>
          </div>
          <spinnerProcessando cssClass="ml-2 mb-2" :status="desabilitarCampos" :mensagem="flagsDeControle.manipulandoDados.mensagem" />
        </div>
      </template>
      <template #corpo>
        <div class="mt-3 d-flex align-items-center flex-column">
          <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12">
          <p class="text-secondary text-bold mb-0">Cadastro Concluído!</p>
          <p class="text-secondary ">Enviamos uma senha temporária para o<br>seu <strong>e-mail</strong> {{ dadosFormulario.email }}.</p>
          </div>
        </div>
        <div class="d-flex justify-content-center mt-2">
          <router-link
            :to="{name: 'loginLite'}"
            :disabled="desabilitarCampos"
            class="btn btn-verde btn-block col-xl-8 col-lg-8 col-md-12 col-sm-12"
            >Efetuar Login</router-link>
        </div>
      </template>
    </PainelAcesso>
  </div>
</template>

<script>
import SignUp from './js'
export default SignUp
</script>

<style scoped>
@import "./scss/signup.scss";
</style>
